export function canAccess(routeName, userRole, router) {
    const route = router.getRoutes().find(r => r.name === routeName)
    if (!route) return false;
    if (!route.meta.roles) return true;
    return route.meta.roles.includes(userRole);
}
